/* Marketplace theme — small vanilla JS layer (no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  /* ------------------------------------------------------------------
     Panels: [data-toggle="id"] opens/closes #id. Panels with
     data-panel="drawer" also show the overlay.
     ------------------------------------------------------------------ */
  const overlay = $('[data-overlay]');
  let openPanel = null;

  function closePanel() {
    if (!openPanel) return;
    const panel = openPanel;
    openPanel = null;
    panel.classList.remove('is-open');
    if (panel.dataset.panel !== 'drawer') panel.hidden = true;
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
    $$('[data-toggle="' + panel.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }

  function openPanelById(id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    if (openPanel === panel) return closePanel();
    closePanel();
    openPanel = panel;
    panel.hidden = false;
    // force reflow so the drawer transition plays
    void panel.offsetWidth;
    panel.classList.add('is-open');
    if (panel.dataset.panel === 'drawer') {
      if (overlay) overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    $$('[data-toggle="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = panel.querySelector('input, button, a, select');
    if (focusable && panel.dataset.panel === 'drawer') focusable.focus();
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-toggle]');
    if (toggle) {
      e.preventDefault();
      openPanelById(toggle.dataset.toggle);
      return;
    }
    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      closePanel();
      return;
    }
    if (openPanel && !openPanel.contains(e.target)) closePanel();
  });

  if (overlay) overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closePanel();
  });

  /* ------------------------------------------------------------------
     Favorites (heart buttons) — stored in localStorage only.
     ------------------------------------------------------------------ */
  const FAV_KEY = 'mp_favorites';

  function readFavs() {
    try {
      return JSON.parse(localStorage.getItem(FAV_KEY) || '[]');
    } catch (err) {
      return [];
    }
  }

  function writeFavs(list) {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(list));
    } catch (err) {
      /* storage unavailable — ignore */
    }
  }

  function renderFavs() {
    const favs = readFavs();
    $$('.fav-btn').forEach((btn) => {
      const url = btn.dataset.favUrl;
      btn.classList.toggle('is-active', favs.some((f) => f.url === url));
    });
    $$('[data-favorites-count]').forEach((el) => {
      el.textContent = favs.length ? String(favs.length) : '';
      el.dataset.count = String(favs.length);
    });
    const list = $('[data-favorites-list]');
    const empty = $('[data-favorites-empty]');
    if (list) {
      list.innerHTML = favs
        .map(
          (f) =>
            '<li class="favorites-panel__item">' +
            (f.image ? '<img src="' + f.image + '" alt="" loading="lazy">' : '<span></span>') +
            '<a href="' + f.url + '" class="favorites-panel__item-title">' + f.title + '</a>' +
            '<span class="favorites-panel__item-price">' + (f.price || '') + '</span></li>'
        )
        .join('');
    }
    if (empty) empty.hidden = favs.length > 0;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.fav-btn');
    if (!btn) return;
    e.preventDefault();
    const favs = readFavs();
    const url = btn.dataset.favUrl;
    const idx = favs.findIndex((f) => f.url === url);
    if (idx > -1) favs.splice(idx, 1);
    else favs.unshift({ url, title: btn.dataset.favTitle, image: btn.dataset.favImage, price: btn.dataset.favPrice });
    writeFavs(favs);
    renderFavs();
  });

  renderFavs();

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const step = btn.dataset.qty === 'up' ? 1 : -1;
    const min = parseInt(input.min || '1', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart quantity change → submit the cart form */
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (input && input.form) input.form.submit();
  });

  /* ------------------------------------------------------------------
     Product page: gallery + variant selection
     ------------------------------------------------------------------ */
  $$('[data-product]').forEach((root) => {
    const slides = $$('.product__slide', root);
    const thumbs = $$('.product__thumb', root);
    let current = Math.max(0, slides.findIndex((s) => !s.hidden));

    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((s, i) => (s.hidden = i !== current));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
      const t = thumbs[current];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    const prev = $('.product__arrow--prev', root);
    const next = $('.product__arrow--next', root);
    if (prev) prev.addEventListener('click', () => show(current - 1));
    if (next) next.addEventListener('click', () => show(current + 1));

    const dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    // Option groups: each [data-option-index] holds a <select> or a set of radios.
    const groups = $$('[data-option-index]', root);
    const idInput = $('input[name="id"]', root);
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare]', root);
    const discountEl = $('[data-discount]', root);
    const addBtn = $('[data-add-to-cart]', root);
    const addText = $('[data-add-to-cart-text]', root);
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    // Mirrors Shopify's money filter for every store money format.
    function money(cents) {
      const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      const key = match ? match[1] : 'amount';
      let decimals = 2;
      let thousands = ',';
      let decimal = '.';
      switch (key) {
        case 'amount_no_decimals':
          decimals = 0;
          break;
        case 'amount_with_comma_separator':
          thousands = '.';
          decimal = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          decimals = 0;
          thousands = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousands = "'";
          break;
        case 'amount_no_decimals_with_space_separator':
          decimals = 0;
          thousands = ' ';
          break;
        case 'amount_with_space_separator':
          thousands = ' ';
          decimal = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousands = ' ';
          break;
      }
      const fixed = (cents / 100).toFixed(decimals);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const value = parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
      return match ? moneyFormat.replace(match[0], value) : value;
    }

    const signalEl = $('.product__signal', root);
    function updateSignal(variant) {
      if (!signalEl) return;
      const threshold = parseInt(signalEl.dataset.threshold || '0', 10);
      const fallback = signalEl.dataset.fallback || '';
      const textEl = signalEl.querySelector('[data-signal-text]');
      const qty = variant.inventory_quantity;
      const tracked = variant.inventory_management;
      let text = '';
      if (variant.available && tracked && qty > 0 && qty <= threshold) {
        text = 'Only ' + qty + ' left — order soon';
      } else if (variant.available && fallback) {
        text = fallback;
      }
      signalEl.hidden = !text;
      if (textEl) textEl.textContent = text;
    }

    function chosenValues() {
      return groups.map((g) => {
        const sel = g.querySelector('select.product-option');
        if (sel) return sel.value;
        const radio = g.querySelector('input.product-option-radio:checked');
        return radio ? radio.value : null;
      });
    }

    function findVariant(values) {
      return variants.find((v) => values.every((val, i) => v.options[i] === val));
    }

    // Marks pills/tiers that lead to a missing or sold-out variant and fills
    // the per-piece price on "buy more, save more" tiles.
    function refreshOptions(chosen) {
      groups.forEach((group, i) => {
        const selected = group.querySelector('[data-option-selected]');
        if (selected) selected.textContent = chosen[i] || '';
        $$('input.product-option-radio', group).forEach((input) => {
          const test = chosen.slice();
          test[i] = input.value;
          const v = findVariant(test);
          const tile = input.closest('label');
          if (!tile) return;
          tile.classList.toggle('is-unavailable', !v || !v.available);
          const priceEl = tile.querySelector('[data-tier-price]');
          if (priceEl) {
            const pcs = parseInt(input.value, 10) || 1;
            priceEl.textContent = v ? money(Math.round(v.price / pcs)) : '—';
          }
        });
        // "Save X%" compared with the smallest pack of the same selection.
        const tiers = $$('.tier', group);
        if (tiers.length) {
          let basePerPc = null;
          tiers.forEach((tile) => {
            const input = tile.querySelector('input');
            const test = chosen.slice();
            test[i] = input.value;
            const v = findVariant(test);
            const pcs = parseInt(input.value, 10) || 1;
            const perPc = v ? v.price / pcs : null;
            if (basePerPc === null && perPc !== null) basePerPc = perPc;
            const saveEl = tile.querySelector('[data-tier-save]');
            if (saveEl) {
              const pct = perPc !== null && basePerPc ? Math.round((1 - perPc / basePerPc) * 100) : 0;
              saveEl.textContent = pct > 0 ? 'Save ' + pct + '%' : '';
            }
          });
        }
      });
    }

    function update() {
      const chosen = chosenValues();
      const variant = findVariant(chosen);
      refreshOptions(chosen);
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          if (addText) addText.textContent = addBtn.dataset.textUnavailable;
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = money(variant.compare_at_price);
      }
      if (discountEl) {
        discountEl.hidden = !onSale;
        if (onSale) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          discountEl.textContent = '(' + pct + '% off)';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? addBtn.dataset.textAdd : addBtn.dataset.textSoldOut;
      }
      updateSignal(variant);
      if (variant.featured_media) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (idx > -1) show(idx);
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach((g) => g.addEventListener('change', update));
    if (groups.length) refreshOptions(chosenValues());
  });

  /* ------------------------------------------------------------------
     Sticky add-to-cart bar (mobile): shows once the real buy box
     scrolls out of view; mirrors price and availability.
     ------------------------------------------------------------------ */
  $$('[data-sticky-atc]').forEach((bar) => {
    const root = bar.closest('[data-product]') || document;
    const realBtn = $('[data-add-to-cart]', root);
    const buyBox = realBtn ? realBtn.closest('.product__buy') || realBtn : null;
    const stickyBtn = $('[data-sticky-add]', bar);
    const stickyPrice = $('[data-sticky-price]', bar);
    const price = $('[data-price]', root);
    const addText = $('[data-add-to-cart-text]', root);
    if (!realBtn || !buyBox || !stickyBtn) return;
    document.body.classList.add('has-sticky-atc');

    stickyBtn.addEventListener('click', () => {
      if (realBtn.disabled) return;
      realBtn.click();
      buyBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    function sync() {
      if (stickyBtn.disabled !== realBtn.disabled) stickyBtn.disabled = realBtn.disabled;
      if (addText && stickyBtn.textContent !== addText.textContent) stickyBtn.textContent = addText.textContent;
      if (price && stickyPrice && stickyPrice.textContent !== price.textContent) stickyPrice.textContent = price.textContent;
    }
    // Watch only the source elements (never the bar itself) to avoid observer loops.
    const mo = new MutationObserver(sync);
    mo.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    if (addText) mo.observe(addText, { childList: true, characterData: true, subtree: true });
    if (price) mo.observe(price, { childList: true, characterData: true, subtree: true });
    root.addEventListener('change', () => setTimeout(sync, 0));
    sync();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          const below = e.boundingClientRect.top > 0; // buy box still further down the page
          const show = !e.isIntersecting && !below;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        },
        { rootMargin: '0px 0px -56px 0px', threshold: 0 }
      ).observe(buyBox);
    }
  });

  /* ------------------------------------------------------------------
     Delivery estimate: in stock at the US warehouse vs made to order
     (counted in business days, Monday to Friday)
     ------------------------------------------------------------------ */
  const etaLang = document.documentElement.lang || 'en';
  const addBusinessDays = (from, n) => {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  };
  const fmtDay = (d) => d.toLocaleDateString(etaLang, { month: 'short', day: 'numeric' });
  const fmtRange = (a, b) => {
    if (a.getTime() === b.getTime()) return fmtDay(a);
    if (a.getMonth() === b.getMonth()) return fmtDay(a) + ' – ' + b.getDate();
    return fmtDay(a) + ' – ' + fmtDay(b);
  };

  /* In-stock estimates for weekend orders start from Monday */
  const nextBusinessDay = (from) => {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    return d;
  };

  $$('[data-eta]').forEach((el) => {
    const today = new Date();
    const out = el.querySelector('[data-eta-text]');
    if (out) {
      const min = parseInt(el.dataset.min || '12', 10);
      const max = Math.max(min, parseInt(el.dataset.max || '19', 10));
      out.textContent = fmtRange(addBusinessDays(today, min), addBusinessDays(today, max));
    }
    const stock = el.querySelector('[data-eta-stock]');
    if (stock) {
      const min = parseInt(el.dataset.stockMin || '4', 10);
      const max = Math.max(min, parseInt(el.dataset.stockMax || '8', 10));
      const ship = nextBusinessDay(today);
      stock.textContent = fmtRange(addBusinessDays(ship, min), addBusinessDays(ship, max));
    }
  });

  /* Shipping timeline: Order placed → Order ships → Delivered (business days) */
  $$('[data-ship-timeline]').forEach((el) => {
    const n = (k) => parseInt(el.dataset[k] || '0', 10) || 0;
    const pmin = n('pmin'), pmax = Math.max(n('pmin'), n('pmax'));
    const smin = n('smin'), smax = Math.max(n('smin'), n('smax'));
    const today = new Date();
    const set = (sel, text) => { const o = el.querySelector(sel); if (o) o.textContent = text; };
    set('[data-tl-placed]', fmtDay(today));
    set('[data-tl-ships]', fmtRange(addBusinessDays(today, pmin), addBusinessDays(today, pmax)));
    set('[data-tl-delivered]', fmtRange(addBusinessDays(today, pmin + smin), addBusinessDays(today, pmax + smax)));
    const stmin = n('stockMin'), stmax = Math.max(n('stockMin'), n('stockMax'));
    const start = nextBusinessDay(today);
    if (stmin) set('[data-tl-stock-delivered]', fmtRange(addBusinessDays(start, stmin), addBusinessDays(start, stmax)));
  });

  /* ------------------------------------------------------------------
     Related products (Shopify recommendations endpoint)
     ------------------------------------------------------------------ */
  $$('[data-recommendations-url]').forEach((el) => {
    fetch(el.dataset.recommendationsUrl)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-recommendations-url]');
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          renderFavs();
        }
      })
      .catch(() => {});
  });

  /* ------------------------------------------------------------------
     Collection filters: submit on sort change
     ------------------------------------------------------------------ */
  $$('[data-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => sel.form && sel.form.submit());
  });
})();

/* ------------------------------------------------------------------
   Product card gallery — ported from Shopify Horizon
   (assets/slideshow.js + previewImage/resetImage in product-card.js):
   - mouse hover on the image shows the next image, leaving goes back
   - arrows (shown on hover) browse the images, looping at the ends
   - touch swipe / mouse drag between images
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('slideshow-component')) return;

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  // Horizon only enables native scrolling while a slideshow is near the viewport,
  // which keeps iOS Safari from running out of compositor layers.
  const viewportObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const slideshow = entry.target;
              if (entry.isIntersecting) {
                slideshow.setAttribute('in-viewport', '');
                if (typeof slideshow.preloadNextImage === 'function') slideshow.preloadNextImage();
              } else {
                slideshow.removeAttribute('in-viewport');
              }
            });
          },
          { rootMargin: '100px' }
        )
      : null;

  class SlideshowComponent extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('slideshow-slides');
      this.slides = this.scroller
        ? Array.from(this.scroller.children).filter((el) => el.tagName === 'SLIDESHOW-SLIDE')
        : [];
      this.current = 0;
      this.userIndex = null;
      this.busy = false;
      this.dragging = false;

      if (viewportObserver) viewportObserver.observe(this);
      else this.setAttribute('in-viewport', '');

      if (this.slides.length <= 1) {
        if (this.slides[0]) this.slides[0].setAttribute('aria-hidden', 'false');
        return;
      }

      this.querySelectorAll('[data-slideshow-action]').forEach((button) => {
        button.addEventListener('click', (event) => {
          if (button.dataset.slideshowAction === 'previous') this.previous(event);
          else this.next(event);
        });
      });

      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
      this.scroller.addEventListener('pointerdown', this.trackPointerType);
      this.scroller.addEventListener('mousedown', this.handleMouseDown);

      // Card hover: show the next image, go back on leave (mouse only).
      this.gallery = this.closest('[data-card-gallery]');
      if (this.gallery) {
        this.gallery.addEventListener('pointerenter', this.previewImage);
        this.gallery.addEventListener('pointerleave', this.resetImage);
      }
    }

    disconnectedCallback() {
      if (viewportObserver) viewportObserver.unobserve(this);
      if (this.scroller) {
        this.scroller.removeEventListener('scroll', this.handleScroll);
        this.scroller.removeEventListener('pointerdown', this.trackPointerType);
        this.scroller.removeEventListener('mousedown', this.handleMouseDown);
      }
      if (this.gallery) {
        this.gallery.removeEventListener('pointerenter', this.previewImage);
        this.gallery.removeEventListener('pointerleave', this.resetImage);
      }
    }

    // Cards with a hover video play it instead of previewing the next image.
    get hasHoverVideo() {
      return Boolean(this.gallery && this.gallery.querySelector('card-video'));
    }

    previewImage = (event) => {
      if (event.pointerType !== 'mouse' || this.hasHoverVideo) return;
      if (this.userIndex != null && this.userIndex > 0) {
        this.select(this.userIndex, null, { animate: false });
      } else {
        this.next(null, { animate: false });
        setTimeout(() => this.preloadNextImage());
      }
    };

    resetImage = (event) => {
      if (event.pointerType !== 'mouse' || this.hasHoverVideo) return;
      this.previous(null, { animate: false });
    };

    next(event, options) {
      if (event) event.preventDefault();
      this.select(this.current + 1, event, options);
    }

    previous(event, options) {
      if (event) event.preventDefault();
      this.select(this.current - 1, event, options);
    }

    async select(requestedIndex, event, options) {
      const animate = !options || options.animate !== false;
      const { slides } = this;

      if (this.busy || slides.length <= 1) return;

      const lastIndex = slides.length - 1;
      const current = this.current;
      let index = requestedIndex;
      if (requestedIndex < 0) index = lastIndex;
      else if (requestedIndex > lastIndex) index = 0;

      if (index === current) return;
      if (event) event.preventDefault();

      const currentSlide = slides[current];
      const targetSlide = slides[index];
      const instant = prefersReducedMotion() || !animate;
      const isAdjacentSlide = Math.abs(index - current) <= 1 && requestedIndex >= 0 && requestedIndex <= lastIndex;

      this.setCurrent(index, event != null);

      if (!instant && !isAdjacentSlide) {
        // Looping or jumping: move the target next to the current slide so the scroll
        // is one slide long, then restore the DOM order.
        this.busy = true;
        await this.scrollFinished;

        const placeholder = document.createElement('slideshow-slide');
        targetSlide.before(placeholder);
        if (requestedIndex < current) currentSlide.before(targetSlide);
        else currentSlide.after(targetSlide);

        this.scrollToSlide(currentSlide, true);
        await this.scrollToSlide(targetSlide, false);

        placeholder.replaceWith(targetSlide);
        this.scrollToSlide(targetSlide, true);
        this.busy = false;
        return;
      }

      this.scrollToSlide(targetSlide, instant);
    }

    setCurrent(index, userInitiated) {
      this.current = index;
      if (userInitiated) this.userIndex = index;
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
      this.preloadNextImage();
      this.dispatchEvent(new CustomEvent('slideshow:select', { bubbles: true, detail: { index, userInitiated } }));
    }

    scrollToSlide(slide, instant) {
      const left = slide.offsetLeft;
      if (Math.abs(this.scroller.scrollLeft - left) < 1) return Promise.resolve();

      this.scroller.scrollTo({ left, behavior: instant ? 'instant' : 'smooth' });
      if (instant) return Promise.resolve();

      this.scrollFinished = this.waitForScrollEnd();
      return this.scrollFinished;
    }

    waitForScrollEnd() {
      return new Promise((resolve) => {
        const scroller = this.scroller;
        let idleTimer;
        const done = () => {
          clearTimeout(idleTimer);
          clearTimeout(maxTimer);
          scroller.removeEventListener('scroll', onScroll);
          resolve();
        };
        const onScroll = () => {
          clearTimeout(idleTimer);
          idleTimer = setTimeout(done, 120);
        };
        const maxTimer = setTimeout(done, 1500);
        idleTimer = setTimeout(done, 120);
        scroller.addEventListener('scroll', onScroll, { passive: true });
      });
    }

    // Preload the image after the current one to avoid white flashes on hover / next.
    preloadNextImage() {
      const nextSlide = this.slides[this.current + 1];
      const image = nextSlide && nextSlide.querySelector('img[loading="lazy"]');
      if (image) image.removeAttribute('loading');
    }

    nearestIndex() {
      const left = this.scroller.scrollLeft;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(slide.offsetLeft - left);
        if (d < distance) {
          distance = d;
          nearest = i;
        }
      });
      return nearest;
    }

    // User swipes / trackpad scrolls: sync the current slide once scrolling settles.
    handleScroll = () => {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        if (this.busy || this.dragging) return;
        const index = this.nearestIndex();
        if (index !== this.current) this.setCurrent(index, true);
      }, 100);
    };

    // Touch taps also emit a compatibility mousedown; only real mice start a drag.
    trackPointerType = (event) => {
      this.lastPointerType = event.pointerType;
    };

    handleMouseDown = (event) => {
      if (event.button !== 0 || this.busy || this.dragging) return;
      if (this.lastPointerType && this.lastPointerType !== 'mouse') return;

      event.preventDefault();

      const startX = event.clientX;
      const startTime = performance.now();
      const startIndex = this.current;
      let previousX = startX;
      let velocity = 0;
      let moved = false;
      let distanceTravelled = 0;

      this.dragging = true;

      const onPointerMove = (moveEvent) => {
        const x = moveEvent.clientX;
        if (!(startX - x)) return;

        if (!moved) {
          moved = true;
          this.setAttribute('dragging', '');
          this.scroller.style.scrollSnapType = 'none';
        }

        const delta = previousX - x;
        velocity = Math.round((delta / (performance.now() - startTime)) * 1000);
        previousX = x;
        distanceTravelled += Math.abs(delta);
        this.scroller.scrollBy({ left: delta, behavior: 'instant' });
      };

      const onPointerUp = async () => {
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        document.removeEventListener('pointercancel', onPointerUp);
        this.dragging = false;
        this.removeAttribute('dragging');

        if (!moved) return;

        // A drag must not open the product link.
        const blockClick = (clickEvent) => {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
        };
        document.addEventListener('click', blockClick, { capture: true, once: true });
        setTimeout(() => document.removeEventListener('click', blockClick, true));

        const nearest = this.nearestIndex();
        const direction = Math.sign(velocity);
        const modifier =
          startIndex !== nearest || Math.abs(velocity) < 10 || distanceTravelled < 10 ? 0 : direction;
        const newIndex = clamp(nearest + modifier, 0, this.slides.length - 1);

        this.setCurrent(newIndex, true);
        await this.scrollToSlide(this.slides[newIndex], false);
        if (!this.dragging) this.scroller.style.scrollSnapType = '';
      };

      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('pointercancel', onPointerUp);
    };
  }

  /* Hover video (ToxDo addition, not in Horizon): plays the product video muted while the
     mouse is over the card image; stops when the mouse leaves or the shopper browses images. */
  class CardVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.gallery = this.closest('.card-gallery') || this.parentElement;
      if (!this.video || !this.gallery) return;

      this.video.muted = true;
      this.video.addEventListener('playing', this.handlePlaying);
      this.gallery.addEventListener('pointerenter', this.play);
      this.gallery.addEventListener('pointerleave', this.stop);
      this.gallery.addEventListener('slideshow:select', this.handleSelect);
    }

    disconnectedCallback() {
      if (!this.video || !this.gallery) return;
      this.video.removeEventListener('playing', this.handlePlaying);
      this.gallery.removeEventListener('pointerenter', this.play);
      this.gallery.removeEventListener('pointerleave', this.stop);
      this.gallery.removeEventListener('slideshow:select', this.handleSelect);
    }

    play = (event) => {
      if (event.pointerType !== 'mouse') return;
      this.hovering = true;
      try {
        this.video.currentTime = 0;
      } catch (e) {
        /* metadata not loaded yet: playback starts at 0 anyway */
      }
      const playing = this.video.play();
      if (playing) playing.catch(() => {});
    };

    // Only show the video once frames are rendering, so the image never flashes black.
    handlePlaying = () => {
      if (this.hovering) this.classList.add('is-playing');
      else this.video.pause();
    };

    stop = (event) => {
      if (event && event.pointerType && event.pointerType !== 'mouse') return;
      this.hovering = false;
      this.classList.remove('is-playing');
      this.video.pause();
    };

    handleSelect = (event) => {
      if (event.detail && event.detail.userInitiated) this.stop();
    };
  }


  /* ------------------------------------------------------------------
     Quick add — ported from Shopify Horizon (quick-add.js, product-form.js,
     fly-to-cart.js). "Add" adds a single-variant product straight to the cart;
     "Choose" opens a popup with the product's options; mode "page" opens the
     product page (personalized / subscription products).
     ------------------------------------------------------------------ */
  const BURST_SVG =
    '<span class="add-to-cart__added" aria-hidden="true"><svg class="checkmark-burst" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<g class="check"><circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>' +
    '<g class="burst">' +
    [0, 1, 2, 3, 4, 5, 6, 7]
      .map(
        (i) =>
          '<g style="--index: ' + i + ';"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"/></g>'
      )
      .join('') +
    '</g></svg></span>';

  const CLOSE_SVG =
    '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M15 5 5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const escapeHtml = (value) =>
    String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const sizedImage = (src, width) => {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  };

  // Mirrors Shopify's money filter for every store money format (same as the product page).
  function formatMoney(cents, moneyFormat) {
    const format = moneyFormat || '${{amount}}';
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = match ? match[1] : 'amount';
    let decimals = 2;
    let thousands = ',';
    let decimal = '.';
    switch (key) {
      case 'amount_no_decimals':
        decimals = 0;
        break;
      case 'amount_with_comma_separator':
        thousands = '.';
        decimal = ',';
        break;
      case 'amount_no_decimals_with_comma_separator':
        decimals = 0;
        thousands = '.';
        break;
      case 'amount_with_apostrophe_separator':
        thousands = "'";
        break;
      case 'amount_no_decimals_with_space_separator':
        decimals = 0;
        thousands = ' ';
        break;
      case 'amount_with_space_separator':
        thousands = ' ';
        decimal = ',';
        break;
      case 'amount_with_period_and_space_separator':
        thousands = ' ';
        break;
    }
    const parts = (cents / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const value = parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    return match ? format.replace(match[0], value) : value;
  }

  async function addToCart(id, quantity) {
    const response = await fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    productCache.clear();
    return data;
  }

  async function refreshCartCount() {
    try {
      const cart = await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('.header__count').forEach((el) => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
        const link = el.closest('a');
        if (link) link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
      });
    } catch (e) {
      /* the count refreshes on the next page load */
    }
  }

  function cartIcon() {
    const icons = Array.from(document.querySelectorAll('a.header__icon-btn[href$="/cart"], a[href$="/cart"] .header__count'));
    const visible = icons.find((el) => el.getClientRects().length);
    return visible ? visible.closest('a') || visible : null;
  }

  // Horizon's fly-to-cart: the product image travels from the button to the cart icon.
  function flyToCart(source, image, variant) {
    const destination = cartIcon();
    if (!source || !destination || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const from = source.getBoundingClientRect();
    const to = destination.getBoundingClientRect();
    const startX = from.left + from.width / 2;
    const startY = from.top + from.height / 2;
    // The ToxDo header scrolls away; when the cart icon is off-screen, fly to the top edge below it.
    const endY = Math.max(to.top + to.height / 2, 0);
    const flyer = document.createElement('fly-to-cart');
    flyer.className = 'fly-to-cart--' + variant;
    if (image) flyer.style.setProperty('background-image', 'url("' + image + '")');
    flyer.style.setProperty('--start-opacity', '0');
    flyer.style.setProperty('--start-x', startX + 'px');
    flyer.style.setProperty('--start-y', startY + 'px');
    flyer.style.setProperty('--travel-x', to.left + to.width / 2 - startX + 'px');
    flyer.style.setProperty('--travel-y', endY - startY + 'px');
    document.body.appendChild(flyer);

    const animations = flyer.getAnimations ? flyer.getAnimations() : [];
    Promise.allSettled(animations.map((a) => a.finished)).then(() => flyer.remove());
    setTimeout(() => flyer.remove(), 2000);
  }

  // Horizon's "added" checkmark burst on the button, reset 800ms after it finishes.
  function showAdded(button) {
    if (!button.querySelector('.add-to-cart__added')) {
      button.insertAdjacentHTML('beforeend', BURST_SVG);
      void button.offsetWidth;
    }
    clearTimeout(button.addedTimer);
    button.dataset.added = 'true';
    button.addedTimer = setTimeout(() => button.removeAttribute('data-added'), 1000 + 800);
  }

  const productCache = new Map();

  async function fetchProduct(handle) {
    if (!productCache.has(handle)) {
      const request = fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      }).then((response) => {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      });
      productCache.set(handle, request);
      request.catch(() => productCache.delete(handle));
    }
    return productCache.get(handle);
  }

  class QuickAddModal {
    constructor() {
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'quick-add-modal';
      this.dialog.setAttribute('aria-label', 'Choose options');
      this.dialog.innerHTML =
        '<button type="button" class="quick-add-modal__close" aria-label="Close">' + CLOSE_SVG + '</button>' +
        '<div class="quick-add-modal__content"></div>';
      this.content = this.dialog.querySelector('.quick-add-modal__content');
      document.body.appendChild(this.dialog);

      this.dialog.querySelector('.quick-add-modal__close').addEventListener('click', () => this.close());
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      // Clicking the backdrop (the dialog box itself, outside its content) closes it.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('change', this.handleChange);
      this.dialog.addEventListener('submit', this.handleSubmit);
    }

    async open(trigger) {
      this.trigger = trigger;
      this.moneyFormat = trigger.dataset.moneyFormat;
      this.productUrl = trigger.dataset.productUrl;
      this.content.innerHTML = '<div class="quick-add-modal__loading">Loading…</div>';

      let product;
      try {
        product = await fetchProduct(trigger.dataset.productHandle);
      } catch (e) {
        window.location.href = this.productUrl;
        return;
      }

      this.render(product);
      if (!this.dialog.open) {
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      this.content.querySelectorAll('.quick-add-modal__media, .quick-add-modal__details').forEach((el) => {
        el.scrollTop = 0;
      });
    }

    close() {
      if (!this.dialog.open || this.dialog.classList.contains('dialog-closing')) return;
      this.dialog.classList.add('dialog-closing');
      const finish = () => {
        this.dialog.classList.remove('dialog-closing');
        this.dialog.close();
        document.documentElement.style.overflow = '';
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else setTimeout(finish, 125);
    }

    render(product) {
      this.product = product;
      const variants = product.variants || [];
      const current = variants.find((v) => v.available) || variants[0];
      const options = (product.options || []).map((option, index) => ({
        name: typeof option === 'string' ? option : option.name,
        values:
          option && option.values
            ? option.values
            : variants.map((v) => v.options[index]).filter((value, i, all) => all.indexOf(value) === i),
      }));
      const hasOnlyDefault = variants.length === 1 && options.length === 1 && options[0].values[0] === 'Default Title';

      const media = (product.media || [])
        .map((m) => {
          const image = m.media_type === 'image' ? m : m.preview_image;
          if (!image || !image.src) return '';
          const ratio = image.aspect_ratio || (image.width && image.height ? image.width / image.height : 1);
          return (
            '<img src="' + escapeHtml(sizedImage(image.src, 800)) + '" alt="' + escapeHtml(m.alt || product.title) +
            '" loading="lazy" data-media-id="' + m.id + '" style="--ratio: ' + ratio + '" width="800" height="' + Math.round(800 / ratio) + '">'
          );
        })
        .join('');

      const optionsHtml = hasOnlyDefault
        ? ''
        : options
            .map((option, index) => {
              const name = escapeHtml(option.name);
              const selected = current ? current.options[index] : '';
              if (option.values.length > 8) {
                return (
                  '<div class="field option-group" data-option-index="' + index + '"><label class="option-group__label" for="QuickAddOption-' + index + '">' + name + '</label>' +
                  '<select id="QuickAddOption-' + index + '" class="quick-add-modal__select" data-option>' +
                  option.values
                    .map((value) => '<option value="' + escapeHtml(value) + '"' + (value === selected ? ' selected' : '') + '>' + escapeHtml(value) + '</option>')
                    .join('') +
                  '</select></div>'
                );
              }
              return (
                '<div class="field option-group option-group--pills" data-option-index="' + index + '">' +
                '<div class="option-group__label"><span>' + name + '</span><span class="option-group__selected" data-option-selected>' + escapeHtml(selected) + '</span></div>' +
                '<div class="pill-options" role="radiogroup" aria-label="' + name + '">' +
                option.values
                  .map(
                    (value) =>
                      '<label class="pill-option"><input type="radio" name="quick-add-option-' + index + '" value="' + escapeHtml(value) + '" data-option' +
                      (value === selected ? ' checked' : '') + '><span class="pill-option__label">' + escapeHtml(value) + '</span></label>'
                  )
                  .join('') +
                '</div></div>'
              );
            })
            .join('');

      const url = escapeHtml(this.productUrl || product.url);
      this.content.innerHTML =
        '<div class="quick-add-modal__media">' + media + '</div>' +
        '<div class="quick-add-modal__details">' +
        '<h2 class="quick-add-modal__title"><a href="' + url + '">' + escapeHtml(product.title) + '</a></h2>' +
        '<div class="quick-add-modal__price" data-qa-price></div>' +
        optionsHtml +
        '<form class="quick-add-modal__buy" novalidate>' +
        '<div class="quantity"><button type="button" data-qty="down" aria-label="Decrease quantity">−</button>' +
        '<input type="number" name="quantity" value="1" min="1" aria-label="Quantity">' +
        '<button type="button" data-qty="up" aria-label="Increase quantity">+</button></div>' +
        '<button type="submit" class="btn add-to-cart-button" data-qa-add><span class="add-to-cart-text" data-qa-add-text>Add to cart</span></button>' +
        '</form>' +
        '<p class="quick-add-modal__error" data-qa-error hidden></p>' +
        '<a class="quick-add-modal__more" href="' + url + '">View more details <span aria-hidden="true">→</span></a>' +
        '</div>';

      this.dialog.setAttribute('aria-label', product.title);
      this.update(current, false);
    }

    selectedValues() {
      return Array.from(this.content.querySelectorAll('[data-option-index]')).map((group) => {
        const select = group.querySelector('select[data-option]');
        if (select) return select.value;
        const radio = group.querySelector('input[data-option]:checked');
        return radio ? radio.value : null;
      });
    }

    findVariant(values) {
      return (this.product.variants || []).find((v) => values.every((value, i) => v.options[i] === value));
    }

    handleChange = (event) => {
      if (!event.target.matches('[data-option]')) return;
      this.update(this.findVariant(this.selectedValues()), true);
    };

    update(variant, scrollToImage) {
      this.variant = variant;
      const money = (cents) => escapeHtml(formatMoney(cents, this.moneyFormat));
      const price = this.content.querySelector('[data-qa-price]');
      if (price) {
        const shown = variant || this.product;
        const compare = shown.compare_at_price;
        price.innerHTML =
          '<span>' + money(shown.price) + '</span>' +
          (compare > shown.price
            ? '<s>' + money(compare) + '</s><span class="quick-add-modal__discount">(' + Math.round(((compare - shown.price) * 100) / compare) + '% off)</span>'
            : '');
      }

      // Selected value labels + crossed-out pills for missing / sold out combinations.
      const chosen = this.selectedValues();
      this.content.querySelectorAll('[data-option-index]').forEach((group, i) => {
        const label = group.querySelector('[data-option-selected]');
        if (label) label.textContent = chosen[i] || '';
        group.querySelectorAll('input[data-option]').forEach((input) => {
          const test = chosen.slice();
          test[i] = input.value;
          const match = this.findVariant(test);
          input.closest('label').classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      const add = this.content.querySelector('[data-qa-add]');
      const addText = this.content.querySelector('[data-qa-add-text]');
      if (add && addText) {
        add.disabled = !variant || !variant.available;
        addText.textContent = !variant ? 'Unavailable' : variant.available ? 'Add to cart' : 'Sold out';
      }
      const error = this.content.querySelector('[data-qa-error]');
      if (error) error.hidden = true;

      if (scrollToImage && variant && variant.featured_media) {
        const image = this.content.querySelector('.quick-add-modal__media [data-media-id="' + variant.featured_media.id + '"]');
        const gallery = this.content.querySelector('.quick-add-modal__media');
        if (image && gallery) gallery.scrollTo({ top: image.offsetTop - gallery.offsetTop, left: image.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      }
    }

    handleSubmit = async (event) => {
      event.preventDefault();
      const button = this.content.querySelector('[data-qa-add]');
      const quantityInput = this.content.querySelector('input[name="quantity"]');
      const error = this.content.querySelector('[data-qa-error]');
      if (!button || !this.variant || !this.variant.available || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      // Like Horizon: the checkmark plays on click (no fly-to-cart from inside the popup).
      showAdded(button);
      try {
        await addToCart(this.variant.id, Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1));
        refreshCartCount();
      } catch (e) {
        clearTimeout(button.addedTimer);
        button.removeAttribute('data-added');
        if (error) {
          error.textContent = e.message;
          error.hidden = false;
        }
      } finally {
        button.removeAttribute('aria-busy');
      }
    };
  }

  let quickAddModal = null;

  class QuickAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-quick-add-button]');
      if (this.button) this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.handleClick);
    }

    handleClick = async (event) => {
      // The button sits inside the card link: never let the click open the product.
      event.preventDefault();
      event.stopPropagation();

      const mode = this.dataset.mode;
      if (mode === 'page') {
        window.location.href = this.dataset.productUrl;
        return;
      }
      if (mode === 'choose') {
        if (!quickAddModal) quickAddModal = new QuickAddModal();
        quickAddModal.open(this);
        return;
      }

      if (this.button.getAttribute('aria-busy') === 'true') return;
      this.button.setAttribute('aria-busy', 'true');
      // Like Horizon: fly-to-cart and the checkmark play on click, before the request finishes.
      flyToCart(this.button, this.dataset.image, 'quick');
      showAdded(this.button);
      try {
        await addToCart(this.dataset.variantId, 1);
        refreshCartCount();
      } catch (e) {
        window.location.href = this.dataset.productUrl;
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    };
  }

  if (!customElements.get('quick-add')) customElements.define('quick-add', QuickAdd);

  customElements.define('slideshow-component', SlideshowComponent);
  if (!customElements.get('card-video')) customElements.define('card-video', CardVideo);
})();
